export const VerificationCodeInput = {
  mounted() {
    const inputs = this.el.querySelectorAll('input[type="text"]')
    const hiddenInput = this.el.querySelector('input[type="hidden"]')

    inputs.forEach((input, idx) => {
      input.addEventListener("input", (e) => {
        e.preventDefault()
        e.stopPropagation()
        sync_hidden_input(inputs, hiddenInput)
        // Only advance when a character was entered. On deletion (Backspace/Delete)
        // the field is left empty and the cursor stays put so it can be retyped.
        if (input.value !== "") {
          maybe_focus_next_input(inputs, idx)
        }
      })

      input.addEventListener("keydown", (e) => {
        // Backspace on an already-empty field steps focus back one field.
        // preventDefault so the browser's default delete doesn't act on the
        // newly-focused previous field — otherwise behavior varies by browser.
        if (e.key === "Backspace" && input.value === "") {
          e.preventDefault()
          maybe_focus_previous_input(inputs, idx)
        }
      })
    })
  },
}

function sync_hidden_input(inputs, hiddenInput) {
  hiddenInput.value = [...inputs].map((elm) => elm.value).join("")
  hiddenInput.dispatchEvent(new Event("input", { bubbles: true }))
}

function maybe_focus_next_input(inputs, idx) {
  if (idx != inputs.length - 1) {
    inputs[idx + 1].focus()
  }
}

function maybe_focus_previous_input(inputs, idx) {
  if (idx > 0) {
    inputs[idx - 1].focus()
  }
}
